import React from 'react';

const FieldSkeleton = ({ labelWidth = '30%', valueHeight = 31 }) => (
  <div className="mb-2">
    <div className="shimmer shimmer-line" style={{ marginBottom: 6, width: labelWidth, height: 10 }} />
    <div
      className="shimmer shimmer-line"
      style={{ width: '100%', height: valueHeight, borderRadius: 4 }}
    />
  </div>
);

const HoaBlockSkeleton = () => (
  <div className="pt-3" aria-busy="true" aria-label="Loading HOA form">
    <div className="d-flex align-items-center justify-content-between mb-2">
      <div className="shimmer shimmer-line" style={{ width: 150, height: 10 }} />
      <div className="shimmer shimmer-line" style={{ width: 110, height: 10 }} />
    </div>

    <FieldSkeleton labelWidth="22%" />

    <div className="row">
      <div className="col-md-6">
        <FieldSkeleton labelWidth="28%" />
      </div>
      <div className="col-md-6">
        <FieldSkeleton labelWidth="24%" />
      </div>
    </div>

    <div className="mb-3">
      <div className="shimmer shimmer-line mb-1" style={{ width: 80, height: 10 }} />
      <div className="shimmer shimmer-line" style={{ width: '100%', height: 64, borderRadius: 4 }} />
    </div>
  </div>
);

export default HoaBlockSkeleton;
